<template>
    <div class="wrapper-card-rounded">
      <v-card class="card-rounded">
        <v-card-text>
          <v-avatar size="100">
              <img src="@/assets/of-logo.png" alt="Outfox AI">
          </v-avatar>
          <h3 class="headline grey--text mb-1">Log into Outfox AI</h3>
          <v-btn dark class="btn-login fbblue" @click.prevent="loginWithFacebook">
              <i class="fab fa-facebook"></i>
              Log in with Facebook</v-btn>
          <!--<div class="subheading grey&#45;&#45;text mt-2">-->
            <!--or-->
            <!--<router-link to="signup">-->
              <!--Create an Account-->
            <!--</router-link>-->
          <!--</div>-->
        </v-card-text>
      </v-card>
    </div>
</template>

<script>
import helpers from '../../helpers/functions'
export default {
  name: 'login',
  computed: {
    setupMode () {
      const setupMode = this.$store.getters.getSetupMode
      return setupMode ? setupMode.status : false
    }
  },
  methods: {
    loginWithFacebook () {
      const promise = new Promise(resolve => {
        resolve(this.$store.dispatch('login'))
      })
      promise.then(res => {
        if (res) {
          if (this.$store.state.featureToggle.appVersion === 'demo') {
            this.$store.dispatch('fetchDemoData')
          } else {
            new Promise(resolve => {
              resolve(this.$store.dispatch('fetchApiData'))
            })
              .then(() => {
                if (this.setupMode) {
                  this.$router.push('/setup-checklist/1/define-key-campaign-dates')
                } else this.$router.push('/campaigns/new')
              })
          }
        } else this.$router.push('/welcome')
      })
        .catch(err => {
          helpers.handleError(err)
          this.$router.push({name: 'ErrorsHandling'})
        })
    }
  }
}
</script>
